import { render, staticRenderFns } from "./PaketKuesionerEdit.vue?vue&type=template&id=64b04f84&"
import script from "./PaketKuesionerEdit.vue?vue&type=script&lang=js&"
export * from "./PaketKuesionerEdit.vue?vue&type=script&lang=js&"
import style0 from "./PaketKuesionerEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports